import React, { FC, useEffect, useState } from "react";
import exploreEvents from "assets/images/common/others/exploreEvents.png";
import locationIcon from "assets/images/svgs/locationIcon.svg";
import iconOne from "assets/images/svgs/iconOne.svg";
import iconTwo from "assets/images/svgs/iconTwo.svg";
import iconThree from "assets/images/svgs/iconThree.svg";
import { ReactComponent as LocationIocn } from "assets/images/common/svgs/locationIcon.svg";

import { FiSearch } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import useUsers from "containers/user-management/useHooks";
import { EVENT_STATUS } from "utils/helpers/enums/shared.enum";
import { EventDTO } from "utils/helpers/models/common/event.dto";
import { EventsFilterDTO } from "utils/helpers/models/users/events-filter.dto";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import DataNotFound from "components/particles/table/data-not-found";
import { useSelector } from "react-redux";
import { json } from "stream/consumers";
import SessionDateBadge from "components/NextSession/SessionDateBadge";

interface Props {
  hostId: any;
}

const Events: FC<Props> = ({ hostId }) => {
  console.log(hostId);
  const navigate = useNavigate();
  const [filters, setFilters] = useState<EventsFilterDTO>(
    new EventsFilterDTO()
  );
  const { getUserEventsById } = useUsers();
  const [data, setData] = useState<EventDTO[]>([]);
  const [totalElements, setTotalElements] = useState<number>(0);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const statusFilterTabs = [
    { title: "Saved", value: EVENT_STATUS.DRAFT },
    { title: "Cancelled", value: EVENT_STATUS.CANCELLED },
  ];
  const timeFilterTabs = [
    { title: "Upcoming Events", value: "upcoming" },
    { title: "Past Events", value: "past" },
  ];

  const getAllEvents = (filterParams: EventsFilterDTO) => {
    const queryParams: any = { hostId, page: 0, size: 8 };
    if (filterParams.isSession !== "") {
      queryParams.isSession = filterParams.isSession;
    }

    // Add other filter parameters
    for (let key in filterParams) {
      if (key !== "hostId" && filterParams[key] !== "") {
        queryParams[key] = filterParams[key];
      }
    }

    getUserEventsById(setData, queryParams, setFilters, setTotalElements);
  };
  // working
  useEffect(() => {
    if (!filters.timeFrame) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        timeFrame: "upcoming",
      }));
    }

    getAllEvents(filters);
  }, []);

  const handleFilterChange = (event: any) => {
    const { name, value } = event.target;
    filters.page = 0;
    const updatedFilters = { ...filters };

    if (name === "isSession") {
      updatedFilters[name] =
        value === "true" ? true : value === "false" ? false : "";
      console.log(updatedFilters[name]);
    }

    if (name === "timeFrame") {
      updatedFilters[name] = value;
      updatedFilters["status"] = undefined;
    } else if (name === "status") {
      updatedFilters[name] = value;
      updatedFilters["timeFrame"] = "";
    }

    setFilters(updatedFilters);

    if (name !== "searchTitle") {
      getAllEvents(updatedFilters);
    }
  };

  console.log(data);

  const handleSeeMore = async (event: any, filterParams: EventsFilterDTO) => {
    event.preventDefault();
    const updatedFilters = { ...filters, page: filters.page + 1 };
    setFilters(updatedFilters);
    const queryParams: any = { hostId, page: updatedFilters.page, size: 8 };
    for (let key in updatedFilters) {
      if (key !== "page" && key !== "hostId" && updatedFilters[key] !== "") {
        queryParams[key] = updatedFilters[key];
      }
    }
    const dataArray = JSON.parse(JSON.stringify(data));
    await getUserEventsById(setData, queryParams, setFilters, setTotalElements);

    // Add the new data to the existing data array
    setData((prevData) => [...dataArray, ...prevData]);
  };

  const goToEventDetail = (id: number) => {
    navigate(`${siteRoutes.hostEventDetailView}?id=${id}`);
  };

  return (
    <div className="">
      <div className="flex flex-wrap items-center justify-between gap-5">
        <div className="flex flex-wrap gap-3 items-center">
          {/* Time Filter Tabs */}
          <div className="">
            <div className="flex gap-3">
              {timeFilterTabs.map((tab, index) => (
                <button
                  key={index}
                  className={`text-xs font-semibold pb-1 flex items-center ${filters.timeFrame === tab.value
                      ? "text-lightBlueColor border-b border-lightBlueColor"
                      : "text-mediumGrayText hover:text-lightBlueColor"
                    }`}
                >
                  <span
                    onClick={() =>
                      handleFilterChange({
                        target: { name: "timeFrame", value: tab.value },
                      })
                    }
                  >
                    {tab.title}
                  </span>
                </button>
              ))}
            </div>
          </div>
          <div className="flex gap-3">
            {statusFilterTabs.map((tab, index) => (
              <button
                key={index}
                className={`text-xs font-semibold pb-1 ${filters.status === tab.value
                    ? "text-lightBlueColor border-b border-lightBlueColor"
                    : "text-mediumGrayText hover:text-lightBlueColor"
                  }`}
              >
                <span
                  onClick={() =>
                    handleFilterChange({
                      target: { value: tab.value, name: "status" },
                    })
                  }
                >
                  {tab.title}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap gap-4 items-center">
          <select
            name="isSession"
            value={filters.isSession || undefined}
            onChange={handleFilterChange}
            className="px-3 border border-lightGrayBorder text-primaryText outline-none rounded-lg text-sm h-[46px] w-full sm:w-auto min-w-[140px]"
          >
            <option value="">Event Type</option>
            <option value="true">Session</option>
            <option value="false">Workshop</option>
          </select>
        </div>
      </div>

      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-[20px] p-6 my-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-6">
          {data.map((exp: EventDTO, index: number) => (
            <div
              onClick={() => goToEventDetail(exp.id)}
              key={index + 1}
              className="p-3 bg-white rounded-xl border border-borderColor cursor-pointer"
            >
              <div className="relative">
                <img
                  src={concatPathWithBackendUrl(
                    exp.eventPicsUrl![0]?.fileDownloadUri
                  )}
                  alt={exp.title}
                  className="w-full h-32 object-cover rounded-xl"
                />
                <div className="">
                  <SessionDateBadge sessions={exp?.workshopSessions || []} />
                </div>
              </div>
              <div className="py-2">
                <h3 className="text-sm font-semibold text-blackie">
                  {exp.title}
                </h3>
                <div className="flex items-center mt-2">
                  {/* <div className="flex -space-x-2">
                                           {[].map((avatar, index) => (
                                                   <img
                                                       key={index}
                                                       src={avatar}
                                                       alt="Attendee"
                                                       className="w-7 h-7 rounded-full border-2 border-white"
                                                   />
                                               ))}
                                         </div> */}
                  <span className="ml-2 text-xs text-darkYellowText">
                    {`${exp?.joineeSlots - exp?.availableSlots}`} + Going
                  </span>
                </div>
                <div className="text-xs text-[#807A7A] mt-2 flex items-start gap-2">
                  <div>
                    <LocationIocn className="w-4" />
                  </div>
                  <span>{exp.location}</span>
                </div>
              </div>
            </div>
          ))} 
        </div>
        <div className="flex justify-center">
          {data.length > 7 && data.length < totalElements && (
            <button
              className="bg-skyLightBg px-3 py-2 rounded-lg text-sm text-primaryText"
              onClick={(e) => handleSeeMore(e, filters)}
            >
              See More
            </button>
          )}
        </div>
        <div className="">
          <DataNotFound show={!isLoading && !data.length} />
        </div>
      </div>
    </div>
  );
};

export default Events;
